{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Žiūrėti visus variantus",
  "Spoiler_Reveal_Tooltip": "Spustelėkite, jei norite sužinoti",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Skelbti „Twitter“",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Elementas suskleistas",
  "Spoiler_Reveal_Video_CTA": "Atskleisti vaizdo įrašą",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Išplėsti vaizdą",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Žiūrėti visus rezultatus",
  "Spoiler_Reveal_Image_Placeholder": "Šiame vaizde yra turinio užuomina",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Slankiklis",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Galite balsuoti už daugiau nei vieną atsakymą.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Rodyti daugiau garso valdiklių",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Uždaryti",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Įkeliamas {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Skaityti daugiau",
  "Spoiler_Insert_Tooltip": "Turinio užuomina",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Garsumas",
  "Spoiler_Reveal_Gallery_Placeholder": "Šioje galerijoje yra turinio užuomina",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Užsakyti",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Nebetildyti",
  "Spoiler_Reveal_Gallery_CTA": "Atskleisti galeriją",
  "Poll_Viewer_ShowLess_CTA": "Rodyti mažiau",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Nutildyti",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} nežinomi (-ų)",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Stebėti",
  "VerticalEmbed_Products_Button": "Pirkti",
  "Poll_Viewer_Toast_Error_ServerDown": "Nepavyko prisijungti prie serverio. Pabandykite vėliau.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "Už šį atsakymą balsavo {{count}}",
  "Poll_Viewer_VoteCount": "Balsai: {{number}}",
  "VerticalEmbed_Events_Button": "Registruotis",
  "Spoiler_Reveal_Image_CTA": "Atskleisti vaizdą",
  "Poll_Viewer_Toast_Error_Connection": "Nėra interneto. Patikrinkite ryšį.",
  "Poll_Viewer_Visibility_Owner_Footer": "Rezultatus matote tik jūs.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "Už šį atsakymą balsavo {{count}}",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Elementas išskleistas",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Šiame vaizdo įraše yra turinio užuomina",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Rodyti visą įrašą",
  "UploadFile_Viewer_Download": "Atsisiųsti {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} val.",
  "VerticalEmbed_Units_Minute": "{{minutes}} min.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
